import React from 'react'
import { Box, Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const dataGridStyle = {
   root: {
     "& .MuiDataGrid-root": {
       borderRadius: '10px',
       backgroundColor: 'white',
       fontSize: '13px',
     },
     "& .MuiDataGrid-columnHeaders": {
       bgcolor: '#f1f8e9',
       fontSize: '15px',
       borderRadius: '10px',
     }
   },
};

function CollapsibleTable({rows}) {
  
  const columns = [
       { field: 'date', headerName: 'Date/Time', flex: 1, minWidth: 100 },
       { field: 'vrm', headerName: 'VRM', flex: 1, minWidth: 100 },
       { field: 'make', headerName: 'Make', flex: 1, minWidth: 200 },
       { field: 'model', headerName: 'Model', flex: 1, minWidth: 100 },
       { field: 'job', headerName: 'Job', flex: 1, minWidth: 100 },
       { field: 'description', headerName: 'Description', flex: 1, minWidth: 100 },
       { field: 'name', headerName: 'Name', flex: 1, minWidth: 100 },
       { field: 'resource', headerName: 'Resource', flex: 1, minWidth: 100 },
       { field: 'staff', headerName: 'Staff', flex: 1, minWidth: 100 },
       {
           field: 'status',
           headerName: 'Status',
           flex: 1,
           minWidth: 100,
           renderCell: (params) => {
             const status = params.value;
             let backgroundColor;
     
             switch (status) {
               case 'In Progress':
                 backgroundColor = '#ffcc80';
                 break;
               case 'completed':
                 backgroundColor = '#81d4fa';
                 break;
               case 'invoiced':
                 backgroundColor = '#a5d6a7';
                 break;
               default:
                 backgroundColor = '#fff59d';
                 break;
             }
     
             return (
               <div
                 style={{
                   backgroundColor,
                   width: '100%',
                   height: '100%',
                   display: 'flex',
                   justifyContent: 'center',
                   alignItems: 'center',

                 }}
               >
                 {params.value}
               </div>
             );
           },
         },
   ];

    

  return (
   <Box mt={2}>
     <Grid container spacing={1}>
        <Grid item xs={12} mt={1}>
         <Box sx={dataGridStyle.root}>
           <DataGrid
           columnHeaderHeight={35}
           rowHeight={35}
             rows={rows}
             columns={columns}
             getRowId={(row) => row.id}
             autoHeight
            //  style={{   marginLeft: '50px' }}
            />
         </Box>
       </Grid>
     </Grid>
   </Box>   
   )
}

export default CollapsibleTable